<div class="content">
    <h1 class="page-title">Departamento</h1>
    <p>
        O Departamento de Capacitação tem como principal responsabilidade à
        formação, atualização e assessoria aos profissionais que trabalham com o
        tênis no Brasil.&nbsp;<br />
        O tênis está sempre se desenvolvendo e se faz necessário que os
        professores acompanhem esta evolução, se atualizando e reciclando
        através de cursos e congressos.<br />
        Uma vez melhorando a formação dos professores, haverá crescimento e
        desenvolvimento do nosso tênis e, por conseqüência, melhores
        oportunidades para todos.<br />
        &nbsp;<br />
        Cesar Kist – Diretor<br />
        Caio Cortela - Assistente<br />
        &nbsp;<br />
        <strong>Equipe Nacional</strong><br />
        Sabrina Giusto (RS)<br />
        Alexandre Peracchi (RS)<br />
        Caio Cortela (PR)<br />
        Eduardo Marcolin (PR)<br />
        Eduardo Figueiredo (PR)<br />
        Elson Longo (SP)<br />
        Suzana Silva (SP)<br />
        Flávio Marreti (SP)<br />
        Domingos Venâncio (RJ)<br />
        Hugo Dereck (ES)<br />
        Paulo Wildmann (MG)<br />
        Joacyr Lima Jr. (MS)<br />
        Ricardo Morais (DF)<br />
        Ary Godoy (BA)<br />
        Eduardo Gordilho (BA)<br />
        Davi Barros (PE)<br />
        Luciano Nery (CE)<br />
        Matheus&nbsp;Wagner (RS)<br />
        &nbsp;<br />
        &nbsp;<br />
        <strong>Objetivos do Departamento</strong><br />
        Promover cursos de formação e atualização, em diferentes regiões do país
        e a custo acessível;<br />
        Elevar o nível de formação dos profissionais que ensinam tênis;<br />
        Prover informação e atualização constantemente;<br />
        Trabalhar com uma equipe nacional de capacitação;<br />
        Integração com os demais departamentos da CBT;<br />
        Oferecer benefícios aos treinadores filiados;<br />
        Valorizar a categoria através do SNGP (Sistema Nacional de Graduação
        Profissional);<br />
        Trabalho em conjunto com as Federações Estaduais.
    </p>
</div>
